module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_12.b0109a07.pdf";